import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { CanActivateFn, Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export const authGuardFn: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    tap((loggedIn) => {
      if (!loggedIn) {
        auth.loginWithRedirect({ appState: { target: router.url } });
      }
    })
  );
};


